# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://coffeescript.org/
appWindow = ''

window.groupCheck = (childSelector, parentSelector, isChecked, allowParentChecked) ->
  indeterminate = false

  parent = $(parentSelector)

  $(childSelector).each(() ->
    if($(this).prop('checked') != isChecked)
      indeterminate = true
      parent.prop('indeterminate', true)
      return false
  )

  if !indeterminate
    parent.prop('indeterminate', !allowParentChecked && isChecked )
    parent.prop('checked', allowParentChecked && isChecked )
    if isChecked
      parent.parent().addClass("folder-highlighted")
    else
      parent.parent().removeClass("folder-highlighted")
  else
    parent.parent().removeClass("folder-highlighted")

window.getUnitFromGroup = (group) ->
  grp = $(".group-check[data-group='" + group + "']")
  if(grp.data("region") != undefined)
#    console.log("Region:" + grp.data("region"))
    return grp.data("region")
  else
#    console.log("Group:" + group)
    return group

window.toggleDisplayLink = (elem) ->
  $(".display-link-selected").removeClass("display-link-selected text-info")
  $(elem).addClass("display-link-selected text-info")

window.toggleAltImg = (elem) ->
  img = $($(elem).children("img[data-altimg]").first())
  src = img.attr("src")
  img.attr("src", img.attr("data-altimg"))
  img.attr("data-altimg", src)

window.linkToApp = (action, method, target) ->
  if(method == "get")
    window.open(action, target)
  else
    #The method: :post command of link_to works by dynamically creating an HTML form and submitting it.  Mimic that behavior here.
    form = $("<form id='test'></form>")
    form.attr("method", "post")
    form.attr("action", action)

    form.attr("style", "display: none;")

    # For now, we're only getting A&P to not reload
    params = getParams(action)

    # New for Atlas and Biology because the key value for 'openWindow' is now 'params.i' instead of 'params.key'
    if (params.type == "Atlas" || params.type == "Biology")
        form.attr("target", params.type)
        form.attr("onsubmit", "openWindow(action,target,'"+params.i+"');return false;")
    else if (params.type == "AnatomyPhysiology" || params.type =="Muscles" || params.type =="PathoPhys")
        form.attr("target", params.type)
        form.attr("onsubmit", "openWindow(action,target,'"+params.key+"');return false;")
    else
        form.attr("target", target)

    $.each({"_method":"post", "authenticity_token":$("#links-table").data("authenticity-token")}, (key, value) ->
      field = $("<input></input")

      field.attr("type", "hidden")
      field.attr("name", key)
      field.attr("value", value)

      form.append(field)
    )

    $(document.body).append(form)
    form.submit();

window.getParams = (url) ->

  params = {}
  split_url = url.split("?")

  # This means that there are parameters in the URL.
  if (split_url.length > 1)

    # The parameters string will always be the second value in the split array.
    url_params = split_url[1]

    # This makes sure that any other values that may contain a question mark and caused an additional
    # split are added to the parameters string.
    for x in [2...split_url.length - 1] by 1
      if (split_url[x] != undefined && split_url[x] != null)
        url_params = url_params + split_url[x];

    raw_vars = url_params.split("&")

    for v in raw_vars
      [key, val] = v.split("=")
      params[key] = decodeURIComponent(val)

  return params

window.openWindow = (action, target, key) ->
    # open new window with target but no url
    appWindow = window.open('', target, '', true)
    # console.log(key);
    try
        #if we've refreshed the page this will throw an exception
        if (appWindow.location.href == 'about:blank')
            appWindow.location.href = action
    catch e
        # Page was refreshed.
#        console.log("Page refreshed.")

    # Send message to app window and switch to tab
    appWindow.focus()
    appWindow.postMessage(key, "*")
    return true

window.createDateTimePicker = (selector, dateFormat = $(selector).data("format"), defaultDate = $(selector).data("default"), appendTarget = undefined) ->
  window.createAccessibleCalendar(selector, {
    dateFormat: dateFormat,
    defaultDate: defaultDate,
    appendTarget: appendTarget
  })
window.createDatePicker = (selector) ->
  curr_picker = window.createAccessibleCalendar(selector, {
    enableTime: false,
    defaultDate: $(selector).data("default"),
    dateFormat: "Y-m-d"
  })
  $(selector).siblings(".input-group-addon.datepicker").on("click", (e) ->
    e.stopPropagation()
    curr_picker.open()
  )

window.addCount = (delta) ->
  setCount(parseInt($("#count").text()) + delta)

window.setCount = (count) ->
  $("#count").text(count)
  $("#count_singular").text(count)
#  if count() == 1
  if count == 1
    $("#singular").show()
    $("#plural").hide()
  else
    $("#singular").hide()
    $("#plural").show()

window.conditionallyDisableFeedbackOptions = ()->
  if($('input[name="unlimited_attempts"][type="checkbox"]').length > 0)
    if($('option[value="after_last"]').length > 0)
      isChecked = $('input[name="unlimited_attempts"][type="checkbox"]').prop("checked")
      $('option[value="after_last"]').prop('disabled', isChecked);
      if(isChecked && $('option[value="after_last"]').prop("selected"))
        $('option[value="always"]').prop("selected", true)
        $('#assignment_detailed_results_setting').val("always").change()

window.openWindowOverview = (action, target) ->
  # Check if appWindow already exists and is open
  if appWindow && !appWindow.closed
    # If the current URL is different from the new one, update the URL
    if appWindow.location.href != action
      appWindow.location.href = action
  else
    # Open new window with target but no URL
    appWindow = window.open('', target, '', true)
    # Set the location to the action URL
    appWindow.location.href = action

  # Focus on the window
  appWindow.focus()

$(document).on "turbolinks:load", ->
  # Activate popovers
  # TODO: If we need popovers with different parameters, modify the selector and add more calls.
  $('[data-bs-toggle="popover"]').popover()

  $("#group-delete-popup").on("show.bs.modal", (event) ->
    $(this).find('form').attr("action", $(event.relatedTarget).data("url"))
  )

  $("input.datetimepicker").each(() ->
    createDateTimePicker(this)
  )

  $("#start-datetimepicker").prop('disabled', $("#assignment-form-date-collapse-select").val() == "false")
  if($("#assignment-form-date-collapse-select").val() != "false")
    $("#startDateField").collapse('show')

  $("#assignment-form-date-collapse-select").on("change", (e) ->
    e.preventDefault()
    $("#start-datetimepicker").prop('disabled', this.value == "false")
    $("#startDateField").collapse(if this.value == "false" then 'hide' else 'show')
  )

  conditionallyDisableFeedbackOptions()
  if($('input[name="unlimited_attempts"][type="checkbox"]').length > 0)
    $('input[name="unlimited_attempts"][type="checkbox"]').on("change", (e) ->
      conditionallyDisableFeedbackOptions()
    )


  $(".child-check-region").on("click", (e) ->
    e.stopPropagation()
  )

  if $("#time-limit-toggle").val() == "yes"
    $("#time-limit-field").show()
  # Begin time limit field code
  # Show time limit field when time limit is checked
  $("#time-limit-toggle").on "change", ->
    if $("#time-limit-toggle").val() == "yes"
      $("#time-limit-field").show()
    else
      $("#time-limit-hour-field").val(0)
      $("#time-limit-minute-field").val(0)
      $("#time-limit-field").hide()

  # End time limit field code

  $(".display-link-quiz").on("click", (e) ->
    toggleDisplayLink(this)
  )

  $(".display-link").on("click", (e) ->
    e.preventDefault()
    $(".asset-row-" + $(".display-link-selected").attr("id")).hide()
    toggleDisplayLink(this)
    $(".asset-row-" + $(this).attr("id") + ":not([data-keep-hidden])").show()
  )

  if $("#assignment-new-2-accordion").length > 0
    groupsToCheck = {}
    unitsToExpand = {}
    checkedChildBoxes = $(".child-check:checkbox:checked")

    #Gather the groups that need to be checked
    checkedChildBoxes.each(() ->
      groupsToCheck[$(this).attr("data-group")] = true
    )

    for group in Object.keys(groupsToCheck)
      groupCheck(".child-check[data-group='" + group + "']",".group-check[data-group='" + group + "']",true,true)
      unitsToExpand[getUnitFromGroup(group)] = true

    for unit in Object.keys(unitsToExpand)
      $("#collapse" + unit).collapse('show')

    setCount(checkedChildBoxes.length)

    #Set the values of the child check boxes when the parent changes
    $(".group-check").on("change", (e) ->
      isChecked = $(this).prop('checked')
      #Get all child check boxes with the same data-group
      $(".child-check[data-group='" + $(this).attr("data-group") + "']").each(() ->
        $(this).prop('checked', isChecked)
      )
      setCount($(".child-check:checkbox:checked").length)
    )

    #Change the value of the parent check box based on the values of the children
    #As far as I can tell, this should only trigger when the user manually changes the value of the check box,
    #meaning there should be no conflict with the previous event.

    $(".child-check").on("change", (e) ->
      isChecked = $(this).prop('checked')
      #Loop through all the other elements and check if there's any that don't match this one
      groupCheck(".child-check[data-group='" + $(this).attr("data-group") + "'][value!='" + $(this).attr("value") + "']",
                 ".group-check[data-group='" + $(this).attr("data-group") + "']",
                 isChecked, true)
      setCount($(".child-check:checkbox:checked").length)
    )



  else if $("#assignment-new-2-accordion-ap").length > 0
    groupsToCheck = {}
    unitsToExpand = {}
    checkedChildBoxes = $(".child-check:checkbox:checked")

    #Gather the groups that need to be checked
    checkedChildBoxes.each(() ->
      groupsToCheck[$(this).attr("data-group")] = true
    )

    for group in Object.keys(groupsToCheck)
      groupCheck(".child-check[data-group='" + group + "']",".group-check[data-group='" + group + "']",true,false)
      unitsToExpand[getUnitFromGroup(group)] = true

    checkedParentBoxes = $(".group-check:checkbox:checked")
    partialCheckedChildren = 0

    checkedParentBoxes.each(() ->
      $(".child-check[data-group='" + $(this).attr("data-group") + "']").each(() ->
        $(this).prop('indeterminate', true)
        partialCheckedChildren += 1
      )
      unitsToExpand[getUnitFromGroup($(this).attr("data-group"))] = true
    )

    for unit in Object.keys(unitsToExpand)
      $("#collapse" + unit).collapse('show')

    setCount(checkedChildBoxes.length + partialCheckedChildren)#checkedParentBoxes.length)

    #Set the values of the child check boxes when the parent changes
    $(".group-check").on("change", (e) ->
      isChecked = $(this).prop('checked')
      changedChildren = 0
      #Get all child check boxes with the same data-group
      $(".child-check[data-group='" + $(this).attr("data-group") + "']").each(() ->
        if ($(this).prop('checked') || $(this).prop('indeterminate')) != isChecked
          changedChildren += 1
        $(this).prop('checked', false)
        $(this).prop('indeterminate', isChecked)
      )

      if !isChecked
        changedChildren = changedChildren * -1

      addCount(changedChildren)
      #setCount($(".child-check:checkbox:checked").length + $(".group-check:checkbox:checked").length)
    )

    #Change the value of the parent check box based on the values of the children
    $(".child-check").on("change", (e) ->
      isChecked = $(this).prop('checked')
      parentSelector = ".group-check[data-group='" + $(this).attr("data-group") + "']"
      childSelector = ".child-check[data-group='" + $(this).attr("data-group") + "'][value!='" + $(this).attr("value") + "']"
      delta = -1
      if $(parentSelector).prop('checked')
        #If the parent was checked, we need to uncheck it and check all its children except the one that was just clicked
        $(this).prop('checked', false)
        $(parentSelector).prop('checked', false)
        $(parentSelector).prop('indeterminate', $(childSelector).length > 0)
        $(childSelector).each(() ->
          $(this).prop('checked', true)
          $(this).prop('indeterminate', false)
        )
      else
        #Loop through all the other elements and check if there's any that don't match this one
        groupCheck(childSelector,
                   parentSelector,
                   isChecked, false)
        if isChecked
          delta = 1

      addCount(delta)
      #setCount($(".child-check:checkbox:checked").length + $(".group-check:checkbox:checked").length)
    )

  $(".assignment-unit-collapse").on("show.bs.collapse", (e) ->
#    console.log($(this))
#    $(this).find(".entry-link:visible")
    $(this).find(".entry-link").not(() ->
      return $(this).css('display') == 'none';
    ).first().children("a").first().trigger( "click" )
  )

  $(".assignment-form-collapse-select").on("change", (e) ->
    e.preventDefault()
    toggleSelectExtraField(this, "#groupNameField")
  )

  if $("#quiz-attempts-unlimited-check").prop('checked') || $("#quiz-attempts-field").val() != "1"
    $("#quiz-attempts-field").prop('disabled', $("#quiz-attempts-unlimited-check").prop('checked'))
    $("#quiz-score-to-keep-field").collapse('show')

  $("#quiz-attempts-unlimited-check").on("change", (e) ->
    checked = $("#quiz-attempts-unlimited-check").prop('checked')
    $("#quiz-attempts-field").prop('disabled', checked)
    if checked
      $("#quiz-score-to-keep-field").collapse('show')
    else if $("#quiz-attempts-field").val() == "1"
      $("#quiz-score-to-keep-field").collapse('hide')
  )
  $("#quiz-attempts-field").on("change", (e) ->
    if this.value == "1"
      $("#quiz-score-to-keep-field").collapse('hide')
    else
      $("#quiz-score-to-keep-field").collapse('show')
  )

  #When the search form is reset, submit the cleared form so that we can reset the contents of the page.
  $("#clearable-search-reset").on("click", (e) ->
    $("#clearable-search-field").val("")
    $("#clearable-search-form").submit()
  )


    # Makes entire row open link
  $(".link-row").each(() ->
    $(this).on("click", (e) ->
      matches = $(this).data("link").match(/type=([^&]*)/)
      linkToApp($(this).data("link"), $(this).data("method"), $(this).data("target"))
    )
  )
    # If in assignment creation, check box.
  $(".asset-row td:not(.preview-td)").each(() ->
    $(this).on("click", (e) ->
      $(this).parent().find(".child-check-region").trigger( "click" )
#        # Does the checkbox exist?
#        if ($(this).find(".child-check-region").length)
#            $(this).find(".child-check-region").trigger( "click" )
#        # Otherwise open link
#        else
#            linkToApp($(this).data("link"), $(this).data("method"), $(this).data("target"))
    )
  )
    #If editing the content of a assignment which is saved as a draft -
    # this checks and alerts the user in the case the assignment already has >1 attempts and the user tries to ass a short answer quiz
  $("#draft-continue").click((event) ->
    update_checked_questions()
    containsShortAnswer = false
    checkedBoxes = $(".quiz-and-question-check:checkbox:checked")
    assignment = $('#assignment').data('data')
    alert = $('#short-answer-draft-warning').data('data')
#    console.log(JSON.stringify(assignment))
    for key in checkedBoxes
      if(key.id == "ShortAnswerQuestion")
        containsShortAnswer = true
        shouldbreak = true
      if(shouldbreak)
        break

    if (containsShortAnswer == true && (assignment.attempts > 1 || assignment.attempts == null) && assignment.draft)
      if confirm(alert)
        document.getElementById('continue_btn').click();
    else
      document.getElementById('continue_btn').click();
#    console.log(assignment)
  )
  $('#bottom-section').removeClass("hidden-section")

  #For Bulk Editing.
  #Set the values of the child check boxes when the parent changes
  #Set the values of the child check boxes when the parent changes
  if $("#bulk-edit-form").length > 0

    $("#bulk-publish-button").on("click", (e) ->
      # Select the form in the bulk publish popup
      publish_form = $('#bulk-edit-form')

      # Remove all existing inputs
      $('#bulk-edit-form').children('input').remove()

      # Append the action as hidden field, in this case it's publish
      $('<input>').attr({
        type: 'hidden',
        id: 'test',
        name: 'edit_action',
        value: 'publish',
      }).appendTo($('#bulk-edit-form'))

      # Get all checked assignments. We don't care about the folders.
      $('.child-check:checkbox:checked').each(() ->
          $('<input>').attr({
            type: 'hidden',
            id: '',
            name: 'assignment_ids[]',
            value: $(this).val()
          }).appendTo($('#bulk-edit-form'))
      )

    )

  # TODO: Move this into more general location
  $('.btn-confirmable').on('click', (e) ->
    e.preventDefault()
    # Get the form the confirmation popup is for
    formID = $(this).attr('data-formID') || $('.confirm-modal').attr('data-form-id')
    # if form has "sent notification" checkbox, popup should have it. Match the state
    $('#confirm-send-notification').prop('checked', $('#' + formID).find('#send_notification').prop('checked'))
    # If state is changed in popup, update it on page.
    $('#confirm-send-notification').on("change", (e) ->
      $('#' + formID).find('#send_notification').prop('checked', $(this).prop('checked'))
    )
    buttonName = $(this).attr("name")
    buttonValue = $(this).attr("value")

    # When Okay is clicked, submit the form.
    $('.confirm-popup-okay').on('click', (event) ->
      if (buttonName != undefined && buttonValue != undefined)
        $("#" + formID).append("<input type='hidden' name='" + buttonName + "' value='" + buttonValue + "' />")

      $('#' + formID).submit()
    )
  )

  $('.confirm-modal-button').on('click', (e) ->
    e.preventDefault()
    $(".confirm-modal-button").attr("disabled", true);
  )

  $('#assignment_point_value').on('blur', (e) ->
    if !$('#assignment_point_value').val()
      $('#assignment_point_value').val(0)
  )
